function foo() {
  console.log(42);
}
